import React, { useState, useEffect } from "react";
import { useSelector, useStore } from "react-redux";
import { Link } from "react-router-dom";
import { findLeadInLists } from "../../Slices/leadListUtils";
import Timer from "../../components/Timer";
import { useNavigate } from "react-router-dom";
import { setId } from "../../Slices/employeeslice.js";
import socket from "../pages/Sales1/socket.js";
import Swal from "sweetalert2";
import {
  timerHistoryPayloadChange,
  timerPayloadUpdate,
} from "../../Slices/user";
import { Modal } from "react-bootstrap";
import { Starttask, updateLoginWorkHistoryThunk } from "../../Slices/timerslice.jsx";

import {
  Avatar_02,
} from "../../Routes/ImagePath";
import { useLocation } from "react-router-dom";
import { setAllNote } from "../../Slices/employeeslice.js";
import { CloseTask } from "../../Slices/timerslice.jsx";
import TaskComponent from "../../components/TaskComponent.jsx";
import { setLoginUserDetails } from "../../Slices/loginUserSlice.jsx";
import { setLoader } from "../../Slices/loaderSlice.jsx";
import { fetchWorkHistoryAndStartTask } from "../../Slices/timerslice.jsx";
import { useDispatch } from "react-redux";
import { AntdButton } from "../../blueplanitUtils/InputField.jsx";
import { attendanceUpdateAsync } from "../../Slices/Thunk/LoginThunk.js";
import { updateWorkHistoryThunk } from "../../Slices/orderSlice.jsx";
import NotificationBell from "../pages/Outlook/notify.js";
import Notify from "../pages/Notify/notifyHeader.js";
import ChatHeaderBadge from "../pages/Chat/ChatHeaderBadge.jsx";
import { addLeadReplyNotif } from "../../Slices/leadReplyNotifsSlice";
import { hardLogoutReload } from "../../databucket";
import WorldClock from "../../components/WorldClock.jsx";
import { useHeaderScale } from "../../blueplanitUtils/useHeaderScale";

const Header = () => {
  const scale = useHeaderScale();
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const UserStatus = useSelector((state) => state?.loginUserInfo?.punchinStatus);
  const [profile, setProfile] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [isRunning, setIsRunning] = useState(false);

  const { timerHistoryPayload } = useSelector(
    (state) => state.user
  );
  const lastAttendenceRecord = useSelector((state) => state.Attendence.attendence);
  const ID = lastAttendenceRecord?.id
  const taskUpdate = useSelector((state) => state.timer.taskUpdate);
  const [elapsedTime, setElapsedTime] = useState(0);


  const [slide, setSlide] = useState(false);
  const navigate = useNavigate();
  const handlesidebar = () => {
    setSlide(!slide);
    document.body.classList.toggle("mini-sidebar");
  };
  
  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setAllNote());
  }, [dispatch]);

  // ── Global listener: capture SES inbound reply events ─────────────────────
  // Read lazily at event time: the lead may be in any open Leads window's list.
  const store = useStore();
  useEffect(() => {
    const handleSesEvent = ({ status, messageId, leadId, from, subject }) => {
      if (status !== 'replied' || !leadId) return;
      const lead = findLeadInLists(store.getState().sales, leadId);
      dispatch(addLeadReplyNotif({
        leadId,
        agencyName: lead?.agencyName || '',
        from: from || '',
        subject: subject || '',
        messageId: messageId || leadId,
        timestamp: new Date().toISOString(),
      }));
    };
    socket.on('email:sesEvent', handleSesEvent);
    return () => socket.off('email:sesEvent', handleSesEvent);
  }, [dispatch, store]);

  const handleProfile = () => {
    setProfile(!profile);
  };

  const location = useLocation();
  let pathname = location.pathname;

  const userid = loginUser?.id;
  const profileDate = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

  const UpdateOnLogout = async (userid) => {

    await dispatch(updateLoginWorkHistoryThunk({
      id: userid,
      endTime: new Date().toISOString(),
    }))
  };
  const userId = userid?.toString();

  useEffect(() => {
    if (!sessionStorage.getItem("isRefreshed")) {

      dispatch(fetchWorkHistoryAndStartTask(userId));

      sessionStorage.setItem("isRefreshed", "true");
    }


    return () => {

    };
  }, [dispatch, userId])

  const handleClose = () => {
    dispatch(CloseTask());
  };

  // Handle Logout with Timer Update
  const HandleLogout = async () => {
    if (!UserStatus) {
      await performLogout();
      return;
    }
    const swalOptions = {
      title: "Choose an Action",
      text: "If you want to punch out, click Punch Out.If you want to log out, click Logout.If you want to do both, click Both.",
      icon: "warning",
      showDenyButton: true,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Punch Out",
      denyButtonText: "Logout",
      cancelButtonText: "Both",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
      customClass: {
        closeButton: "swal-no-border",
        confirmButton: "swal2-confirm",
        denyButton: "swal2-cancel",
        cancelButton: "swal2-cancel-red",
      },
    };

    Swal.fire(swalOptions).then(async (result) => {
      if (result.isConfirmed) {
        await dispatch(attendanceUpdateAsync({
          id: ID,
          empid: loginUser?.id,
          input: {
            punchOut: Date.now().toString(),
            status: false,
          },
        }))
        dispatch(setLoader(false));
      } else if (result.isDenied) {
        await performLogout();
        dispatch(setLoader(false));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        await dispatch(attendanceUpdateAsync({
          id: ID,
          empid: loginUser?.id,
          input: {
            punchOut: Date.now().toString(),
            status: false,
          },
        }))
        dispatch(setLoginUserDetails({
          ...profileDate,
          punchInStatus: false,
        }));
        await performLogout();
      }
    });
  };


  const performLogout = async () => {
    socket.off('newGraphNotification');
    socket.off('registerUser');
    socket.removeAllListeners();
    socket.disconnect();
    socket.close();
    const Logoutpayload = {
      department: "",
      task: "",
      time: "",
      requestId: "",
    };
    dispatch(setId(false));
    const payload = { logOut: true };
    UpdateOnLogout(userid);

    dispatch(timerHistoryPayloadChange({ data: payload }));
    dispatch(timerPayloadUpdate({ data: payload }));

    const logoutUpdatePayload = {
      userId: userid,
      endTime: Date.now().toString(),
      emailId: "",
      requestId: "",
      clientName: "Blueplanit",
      processType: "",
      taskType: "Loggingout",
      email: "",
      subject: "",
      body: "",
      startTime: "",
    };
    try {
      const result = await dispatch(updateWorkHistoryThunk(logoutUpdatePayload))
      if (result) {
        if (timerHistoryPayload?.logOut) {
          dispatch(timerPayloadUpdate());
          hardLogoutReload(); // full clear + reload to login (shared-machine isolation)
        } else {
          dispatch(Starttask(Logoutpayload));
          hardLogoutReload(); // full clear + reload to login (shared-machine isolation)
        }
      } else {
        alert("An Error Occurred while Updating Timer");
      }
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  useEffect(() => {
    let intervalId;
    if (isRunning) {
      intervalId = setInterval(() => {
        const currentTime = new Date().getTime();
        const timeDifference = currentTime - parseInt(startTime);
        setElapsedTime(timeDifference);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isRunning, startTime]);

  const username = `${profileDate?.firstname} ${profileDate?.lastname}`

  return (
    <div className="header" style={{ right: "0px" }}>
      {/* Logo */}
      <div className="header-left">
        <Link to="/admin-dashboard" className="logo"></Link>
        <Link to="/admin-dashboard" className="logo2">
        </Link>
      </div>
      {/* /Logo */}
      <Link
        id="toggle_btn"
        to="#"
        style={{
          display: pathname.includes("tasks")
            ? "none"
            : pathname.includes("compose")
              ? "none"
              : "",
        }}
        onClick={handlesidebar}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>
      {/* Header Title */}
      <div className="page-title-box">
        <h3>BluePlanIt</h3>
      </div>
      {/* /Header Title */}
      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link>
      {/* Header Menu */}
      <ul className="nav user-menu">
        {/* Search */}
        <li className="nav-item">
          <div className="top-nav-search">
            <Link to="#" className="responsive-search">
              <i className="fa fa-search" />
            </Link>
          </div>
        </li>

        {/* TEMP — Webtop (Win11 redesign) preview entry. Removed at cutover. */}
        <li className="nav-item" style={{ display: "flex", alignItems: "center" }}>
          <button
            onClick={() => navigate("/webtop")}
            title="Open Webtop preview (Windows 11 redesign)"
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.4)",
              cursor: "pointer",
              padding: "3px 8px",
              borderRadius: 4,
              color: "#fff",
              fontSize: 13,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <span style={{ fontSize: 14 }}>⊞</span> Webtop
          </button>
        </li>

        <WorldClock />

        <Timer />
        <Modal show={taskUpdate} style={{ top: '10%' }}>
          <Modal.Header style={{ position: "relative" }}>
            <Modal.Title>Update Task</Modal.Title>
            <AntdButton
              onClick={handleClose}
              label="×"
              style={{
                background: "none",
                border: "none",
                fontSize: "20px",
                color: "black",
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
            />
          </Modal.Header>
          <Modal.Body>
            <TaskComponent />
          </Modal.Body>
        </Modal>
        <ChatHeaderBadge />
        <NotificationBell />
        <Notify />
        <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleProfile}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // Ensure the name and image are centered
              gap: "8px", // Add spacing between image and name
            }}
          >
            <span className="user-img me-1" style={{ display: "flex", alignItems: "center" }}>
              {profileDate?.image ? (
                <img
                  src={profileDate?.image}
                  alt="User"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#ccc",
                    color: "#333",
                    border: "2px solid #ddd",
                    objectFit: "cover", // Ensures the image doesn't stretch
                  }}
                />
              ) : (
                <img src={Avatar_02} alt="img" style={{ width: "30px", height: "30px", borderRadius: "50%" }} />
              )}
              <span className="status online" />
            </span>
            <span style={{ fontSize: `${12 * scale}px`, whiteSpace: "nowrap" }}>
              {username?.length > Math.round(12 * scale) ? `${username.slice(0, Math.round(12 * scale))}...` : username}
            </span>
          </Link>

          <div
            className={`dropdown-menu dropdown-menu-end ${profile ? "show" : ""
              }`}
          >
            <Link
              className="dropdown-item"
              to="/profile"
              onClick={() => {
                dispatch(setId(true));
              }}
            >
              My Profile
            </Link>
            <Link className="dropdown-item" to="/settings/companysetting">
              Settings
            </Link>
            <Link className="dropdown-item" >
              <p onClick={HandleLogout}>Logout</p>
            </Link>
          </div>
        </li>
      </ul>
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link className="dropdown-item" to="/profile">
            My Profile
          </Link>
          <Link className="dropdown-item" to="/settings/companysetting">
            Settings
          </Link>
          <Link className="dropdown-item" to="/login">
            <p onClick={HandleLogout}>Logout</p>
          </Link>
        </div>
      </div>
      {/* /Mobile Menu */}
    </div>
  );
};

export default Header;
